@if (compact()) {
  <button
    #trigger
    id="onboarding-user-dropdown"
    type="button"
    class="p-0 border-none bg-transparent cursor-pointer"
    [attr.aria-label]="currentUser()?.name"
    (click)="toggleMenu($event)"
  >
    <p-avatar
      [label]="currentUser()?.name?.[0] || ''"
      size="large"
      shape="circle"
      [style]="{ 'background-color': 'var(--p-primary-color)', color: 'var(--p-button-primary-color)' }"
    ></p-avatar>
  </button>
} @else {
  <p-avatar [label]="currentUser()?.name?.[0] || ''" size="large" shape="circle" [style]="{ 'background-color': 'var(--p-primary-color)', color: 'var(--p-button-primary-color)' }"></p-avatar>
  <div class="flex flex-col grow">
      <span>{{currentUser()?.name}} {{currentUser()?.surname}}</span>
      <span class="text-sm">{{currentUser()?.email}}</span>
  </div>
  <button #trigger id="onboarding-user-dropdown" pButton [text]="true" [rounded]="true" severity="secondary" (click)="toggleMenu($event)">
    <i class="fa-solid fa-ellipsis-vertical"></i>
  </button>
}

@if (menuOpen) {
  <div class="user-context-menu" [style.top.px]="menuTop">
    @for (item of items(); track item.label) {
      @if (item.routerLink) {
        <a class="user-context-menu-item" [routerLink]="item.routerLink" (click)="menuOpen = false">
          <i [class]="item.icon"></i>
          <span>{{ item.label }}</span>
        </a>
      } @else {
        <button class="user-context-menu-item" (click)="item?.command({}); menuOpen = false">
          <i [class]="item.icon"></i>
          <span>{{ item.label }}</span>
        </button>
      }
    }
  </div>
}
